import Button from '@mui/material/Button';
import Card from '@mui/material/Card';
import CardContent from '@mui/material/CardContent';
import Typography from '@mui/material/Typography';
import List from '@mui/material/List';
import ListItem from '@mui/material/ListItem';
import { useState } from 'react';
import EnergySlider from '../MarkerModals/components/EnergySlider/EnergySlider';
import ElectricBoltIcon from '@mui/icons-material/ElectricBolt';
import { apiCallsProfile } from "../../api/calls/profile";
import { apiCallsPillars } from '../../api/calls/pillarControl';

export const SendLightCommand = ({ actionImage, deviceChoice, devices = [], deviceType }) => {
    const [energyValue, setEnergyValue] = useState(100);

    const handleSliderChange = (event, newValue) => {
        setEnergyValue(newValue);
    };

    const sendDimUpdate = async () => {
        const userConfirmed = window.confirm(
          "Είστε σίγουρος ότι επιθυμείτε να αλλάξετε το επίπεδο του φωτισμού;"
        );
        
        if (!userConfirmed) {
          return;
        }

        try {
            const deviceIds = devices.map(device => device.id);
            var result;
            if (deviceType === "autonomus") {
                result = await apiCallsProfile.Actions.SendToSelectedPolygon(energyValue.toString(), deviceIds);
            }
            else {
                result = await apiCallsPillars.Actions.SendToSelectedPolygon(energyValue.toString(), deviceIds);
            }
            
            if (result.status === 200) 
                alert("Το Επίπεδο Φωτισμού άλλαξε");
            else
                alert("Αποτυχία αλλαγής επιπέδου φωτισμού");
            
        } catch (error) {
          console.error("Η αλλαγή Επιπέδου φωτισμού απέτυχε:", error);
          
          alert("Η αλλαγή Επιπέδου φωτισμού απέτυχε. Παρακαλούμε Προσπαθήστε αργότερα.");
        }
    }
    
    return (
        <Card sx={{ height: '100%', minHeight: '400px', minWidth: '400px', display: 'flex', flexDirection: 'column' }}>
            <CardContent sx={{ flexGrow: 1, display: 'flex', flexDirection: 'column' }}>
                <div style={{ textAlign: 'center', marginBottom: '20px' }}>
                    <i className={actionImage} style={{ fontSize: '60px' }} />
                    <Typography variant="h6">{deviceChoice}</Typography>
                </div>
                <div style={{ flexGrow: 1, overflow: 'auto', marginBottom: '20px' }}>
                {deviceChoice === "επιλεγμένες συσκευές" && devices.length !== 0 && (
                    <>
                        <Typography>Σύνολο Συσκευών: {devices.length}</Typography>

                        <List dense style={{ maxHeight: 200, overflowY: 'auto' }}>
                        {devices.map((marker, index) => (
                            <ListItem key={index}>
                            {marker.deviceUid}
                            </ListItem>
                        ))}
                        </List>
                    </>
                )}


                </div>
                <div>
                    <Typography>Επίπεδο Φωτισμού: {energyValue}</Typography>
                    <EnergySlider value={energyValue} onChange={handleSliderChange} />
                    <Typography>Αποστολή σε {deviceChoice}</Typography>
                </div>

                <Button
                    variant="contained"
                    startIcon={<ElectricBoltIcon />}
                    sx={{ mt: 2, alignSelf: 'flex-start' }}
                    onClick={sendDimUpdate}
                >
                    Αποστολή
                </Button>
            </CardContent>
        </Card>
    );
}

export default SendLightCommand;